export default {
  getOrgTaxRate: (state) => state.orgTaxRate,
};
